export const timeline = {
today: "Heute",
yesterday: "Gestern",
emptyTitle: "Noch keine Aktivität",
emptySub: "Ereignisse zu diesem Vorgang erscheinen hier, sobald sie eintreten.",
filters: {
  contact: "Kontakt",
all: "Alle",
asset: "Anlage",
inspection: "Inspektion",
job: "Auftrag",
request: "Anfrage",
report: "Bericht",
},
summary: {
label: "KI-Zusammenfassung",
sinceToggle: "Seit meinem letzten Besuch",
btnSummarise: "Zusammenfassen",
btnRegenerate: "Neu generieren",
btnLoading: "Wird zusammengefasst …",
loading: "Zeitachse wird gelesen …",
emptyHint: "Auf „Zusammenfassen\" tippen für einen 2-4-Satz-Überblick zu dieser Anlage.",
emptyHintSite: "Auf „Zusammenfassen\" tippen für einen 2-4-Satz-Überblick zu diesem Standort.",
emptyHintContact: "Auf „Zusammenfassen\" tippen für einen 2-4-Satz-Überblick zu diesem Kontakt.",
errorFallback: "Zusammenfassung konnte nicht geladen werden. Bitte erneut versuchen.",
},
events: {
assetCreated: "Anlage angelegt",
inspectionStarted: "Inspektion gestartet",
inspectionCompleted: "Inspektion abgeschlossen",
issueRaised: "Mangel gemeldet",
requestRaised: "Anfrage erstellt",
approvalReceived: "Freigabe erhalten",
quoteReceived: "Angebot erhalten",
jobCreated: "Auftrag erstellt",
jobAssigned: "Auftrag zugewiesen",
workCompleted: "Arbeit abgeschlossen",
evidenceAdded: "Nachweis hinzugefügt",
reportGenerated: "Bericht erstellt",
},
};
